import { useEffect, useMemo, useState } from "react"
import { make_radar, shipMargin } from "./utils"
import { Cell } from "./Cell"
import { doIntersect } from "./intersect"
import incorrect from "../../../assets/audio/incorrect.mp3"
import toast from "react-hot-toast"

export const EditableGrid = ({
  animations,
  ships,
  setShips,
  size,
  holding,
  setHolding,
  orientation,
  cleanGrid,
  selected,
  setSelected,
}) => {
  const css_class = "crosswords ocean editable" + (animations ? "animated" : "")

  const interects = useMemo(
    () => (x, y, n, orientation) => {
      const desde1 = { x, y },
        hasta1 = orientation === "h" ? { x: x + n - 1, y } : { x, y: y + n - 1 }

      // doIntersect
      return (
        ships.length &&
        ships.some((s) => {
          const desde2 = { x: s.pos.x, y: s.pos.y },
            hasta2 =
              s.dir === "h"
                ? { x: s.pos.x + s.len - 1, y: s.pos.y }
                : { x: s.pos.x, y: s.pos.y + s.len - 1 }

          return doIntersect(desde1, hasta1, desde2, hasta2)
        })
      )
    },
    [ships]
  )

  const elem = holding ? holding : selected

  const entra = useMemo(
    () => (x, y) => orientation === "h" ? size - x >= elem : size - y >= elem,
    [orientation, size, elem]
  )

  const handleDrop = (x, y, setFunction) => {
    if (!holding && !selected) return

    // intersecta a otro barco o no entra?
    if (!entra(x, y) || interects(x, y, elem, orientation)) {
      new Audio(incorrect).play()
      toast.error("The fish doesn't fit there")
      if (!entra(x, y)) setFunction(null)
      return
    }

    const occupied = ships.some((s) => s.pos.x === x && s.pos.y === y)
    if (occupied) return

    setShips((c) => {
      let n = c.slice(),
        boat = { len: elem, pos: { x, y }, dir: orientation }
      n.push(boat)
      return n
    })

    setFunction(null)
    let m = make_radar(size, size, ships)
    setRadar(m)
  }

  const onMouseOver = (e, isDrag) => {
    e.preventDefault()

    if (isDrag) e.dataTransfer.dropEffect = "copy"

    if (!e.target.classList.contains("cell")) return

    const t = getCellCoords(e),
      esMismo = t.x === lastHover.x && t.y === lastHover.y

    // si sigo en el mismo cuadradito, no actualizo
    if (esMismo) return

    lastHover = t
    let m = make_radar(size, size, ships)

    const err = !entra(t.x, t.y) || interects(t.x, t.y, elem, orientation)
    if (orientation === "h")
      for (let offset = 0; offset < Math.min(elem, 6 - t.x); offset++)
        m[t.y][t.x + offset].status = "preview" + (err ? " red" : "")
    else
      for (let offset = 0; offset < Math.min(elem, 6 - t.y); offset++)
        m[t.y + offset][t.x].status = "preview" + (err ? " red" : "")

    setRadar(m)
  }

  const [radar, setRadar] = useState(make_radar(size, size, ships))

  useEffect(() => {
    let m = make_radar(size, size, ships)
    setRadar(m)
  }, [cleanGrid, ships, size])

  let lastHover = { x: null, y: null }

  return (
    <>
      <div
        className={css_class}
        onDragOver={(e) => onMouseOver(e, true)}
        onMouseOver={(e) => onMouseOver(e, false)}
        onDrop={(e) => {
          e.preventDefault()

          if (!e.target.classList.contains("cell")) return

          handleDrop(
            parseInt(e.target.dataset.x),
            parseInt(e.target.dataset.y),
            setHolding
          )
        }}
        onClick={(e) => {
          e.preventDefault()

          if (!e.target.classList.contains("cell")) return

          handleDrop(
            parseInt(e.target.dataset.x),
            parseInt(e.target.dataset.y),
            setSelected
          )
        }}>
        {ships.map((s, six) => (
          <div
            key={six}
            className="ship"
            data-dir={s.dir}
            data-len={s.len}
            style={shipMargin(s)}></div>
        ))}

        {radar.map((row, rix) => (
          <div key={rix} className="cell-row">
            {row.map((cell, cix) => (
              <Cell key={cix} x={cix} y={rix} cell={cell} />
            ))}
          </div>
        ))}
      </div>
    </>
  )
}

const getCellCoords = (e) => ({
  x: parseInt(e.target.dataset.x),
  y: parseInt(e.target.dataset.y),
})
